<template>
  <v-list color="transparent" class="pa-0 custom-height">
    <v-list-item class="pa-0">
      <template>
        <v-list-item-content>
          <v-list-item-title class="body-2">
            Confirm bets before placing
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch
            v-model="userConfig.confirmStatus"
            :loading="loading"
            color="green"
            inset
            hide-details
            @change="updateConfig"
          ></v-switch>
        </v-list-item-action>
      </template>
    </v-list-item>
  </v-list>
</template>
<script>
import { mapState } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'

export default {
  data() {
    return {
      userConfig: {}
    }
  },
  computed: {
    ...mapState({
      loading: (state) => state.settings.loading
    })
  },
  async created() {
    if (!this.$store.state.settings.userConfig) {
      await this.$store.dispatch('settings/getUserConfig')
      this.userConfig = cloneDeep(this.$store.state.settings.userConfig)
    } else {
      this.userConfig = cloneDeep(this.$store.state.settings.userConfig)
    }
  },
  methods: {
    async updateConfig() {
      await this.$store.dispatch('settings/setUserConfig', this.userConfig)
      this.userConfig = cloneDeep(this.$store.state.settings.userConfig)
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-height {
  height: 38px;
}
</style>